import { EvaluatedFactor, Factor } from './factor';

export function isEvaluatedFactor(factor: Factor | EvaluatedFactor): factor is EvaluatedFactor {
  return 'expressionFunction' in factor;
}
